import { configureStore } from '@reduxjs/toolkit'
import paymentSlice from './stripeReducer';
import threadReducer from './threadSlice';
import inboxReducer from './inboxSlice';
export default configureStore({
  reducer: {
    stripeDetails : paymentSlice.reducer,
    thread: threadReducer,
    inbox: inboxReducer,
  },
})